import React from 'react';
import './UnderConstructionPanel.scss';

export default function UnderConstructionPanel({ moduleName = 'This area', active = true, children }) {
  if (!active) {
    return children || null;
  }

  return (
    <div className="under-construction-gate">
      <div className="under-construction-gate-content" aria-hidden="true">
        {children}
      </div>
      <div
        className="under-construction-gate-overlay"
        role="status"
        aria-live="polite"
        aria-label={`${moduleName} is under construction`}
      >
        <span className="under-construction-gate-label">{moduleName} is under construction</span>
      </div>
    </div>
  );
}
